import { render, staticRenderFns } from "./WebPhoneNetGSM.vue?vue&type=template&id=c54561ae&scoped=true"
import script from "./WebPhoneNetGSM.vue?vue&type=script&lang=js"
export * from "./WebPhoneNetGSM.vue?vue&type=script&lang=js"
import style0 from "./WebPhoneNetGSM.vue?vue&type=style&index=0&id=c54561ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54561ae",
  null
  
)

export default component.exports